import { createReducer } from '@reduxjs/toolkit';

import { CONTRACT_AUTHENTICATION_INITIALIZE } from '@app/store/actionTypes';
import { fetchContractAuthentication } from '@app/store/contract-authentication/actions';

export type ContractAuthenticationAuthenticationKeyState = string | null;

const initialState: ContractAuthenticationAuthenticationKeyState = null;

const reducer = createReducer<string | null>(initialState, (builder) =>
  builder
    .addCase(CONTRACT_AUTHENTICATION_INITIALIZE, () => initialState)
    .addCase(fetchContractAuthentication.pending, () => initialState)
    .addCase(fetchContractAuthentication.fulfilled, (_, action) => action.payload.authKey)
);

export default reducer;
